import { useUser } from '@clerk/nextjs';
import { useSupportConciergeEnabled } from '@web-app/utils/feature-flags/support-concierge';
import { trpc } from '@web-app/utils/trpc';

import { retryExpiredSession } from './useSupportConversations';

export function useSupportAvailability(eligible = true) {
  const { user } = useUser();
  const viewerId = user?.id ?? '';
  const rolloutEnabled = useSupportConciergeEnabled();
  const availability = trpc.supportConcierge.availability.useQuery(
    { viewerId },
    {
      enabled: rolloutEnabled && Boolean(viewerId) && eligible,
      staleTime: 60_000,
      gcTime: 0,
      ...retryExpiredSession,
      refetchOnWindowFocus: true,
    },
  );
  const enabled =
    rolloutEnabled &&
    Boolean(viewerId) &&
    eligible &&
    !availability.isError &&
    availability.data?.enabled === true;
  return {
    viewerId,
    rolloutEnabled,
    availability,
    enabled,
    /** Prescriber resolve is configured for this environment. */
    resolveEnabled: enabled && availability.data?.resolveEnabled === true,
  };
}
